import { createFileRoute } from '@tanstack/react-router';
import { SettingsSyncDetailPage } from '@/features/settings/ui/SyncHistoryAllPage';

export const Route = createFileRoute('/_authenticated/archive/history/$id')({
  component: function ArchiveHistoryDetail() {
    const { id } = Route.useParams();
    return <SettingsSyncDetailPage id={id} />;
  },
});
